/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp } from '../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'

export class AddMultipleTagDto { id = ""; name = ""; subTagList: object[] = []; }

type Props = {}
const animatedComponents = makeAnimated();
const AddMultipleTagModal: FC<Props> = ({ }) => {
  const [isTagSuggestionsGetted, setIsTagSuggestionsGetted] = React.useState(false);

  const createChannelSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, LanguageHelp('Minimum 3 symbols'))
      .max(50, LanguageHelp('Maximum 50 symbols'))
      .required(LanguageHelp('Tag is required')),
    type: Yup.string(),
    subTagList: Yup.array().when('type',
      (type, schema) => {
        if (isTagSuggestionsGetted) {
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
          }))
        } else {
          return schema;
        }
      }),
  })
  const [addMultipleTagDto, setAddMultipleTagDto] = useState(new AddMultipleTagDto())
  const { mode } = useThemeMode()

  const formik = useFormik({
    initialValues: addMultipleTagDto,
    // initialTouched:{ 
    //   name: true,
    //   subTagList: true,
    // },
    validationSchema: createChannelSchema,
    // validateOnMount: true,
    onSubmit: async (values, { setSubmitting }) => {
      isSuccess = false
      try {
        var isSuccess = await addMultipleTagModal(values)
        console.log(isSuccess, "isSuccess")
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(true)
        document.getElementById("buttonCreateDismiss")?.click()
        if (isSuccess == true) {
          document.body.classList.remove('modal-open')
          formik.resetForm();
          setIsTagSuggestionsGetted(false);
        }
      }
    },
  })

  const addMultipleTagModal = async (addMultipleTagDto: AddMultipleTagDto) => {
    var subTagList: string[] = []
    addMultipleTagDto.subTagList.forEach(tagOption => {
      subTagList.push(Object(tagOption)['label'])
    });

    var payload = {
      name: addMultipleTagDto.name,
      subTags: subTagList,
    }

    return axios
      .post(`${process.env.REACT_APP_API_URL}/reviewtag/AddOrUpdateReviewTag`, payload)
      .then((response) => {
        if (response.data.httpStatusCode === 200) {

          if (response.data.message !== null) {
            toast.warning(LanguageHelp(response.data.message));
          } else {
            toast.success(response.data.result);
          }
        } else {
          toast.error(response.data.message);
        }
        return response.data.result;
      })
      .then((response: any) => response != null)
  }

  return (
    <div className='modal fade' id='kt_modal_AddMultipleTag' aria-hidden='true'>
      {/* <div className='modal-dialog modal-xl'> */}
      <div className='modal-dialog modal-dialog-centered mw-750px'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Add Multiple Tag')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonCreateDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >
                {/* begin::Input group */}
                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Tag')}</label>
                    <div className='col-lg-8 fv-row'>
                      <input
                        placeholder={LanguageHelp('Tag')}
                        {...formik.getFieldProps('name')}
                        type='text'
                        name='name'
                        className={clsx('form-control form-control-lg form-control-solid')}
                        autoComplete='off'
                        disabled={formik.isSubmitting}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.name}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Sub Tags')} {LanguageHelp('(optional)')}</label>
                    <div className='col-lg-8 fv-row'>
                      <CreatableSelect
                        defaultValue={[]}
                        isMulti
                        className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                        classNamePrefix="select"
                        isClearable={true}
                        isSearchable={true}
                        components={animatedComponents}
                        noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                        placeholder={LanguageHelp('Write one/several tag(s)...')}
                        formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                        {...formik.getFieldProps('subTagList')}
                        onChange={(subTagList) => formik.setFieldValue('subTagList', subTagList)}
                        onCreateOption={(inputValue) => {
                          const values = inputValue.split(',').map(v => v.trim()).filter(v => v);
                          const current = formik.values.subTagList || [];
                          const newValues = [
                            ...current,
                            ...values.map(v => ({ label: v, value: v }))
                          ];
                          formik.setFieldValue('subTagList', newValues);
                        }}
                        styles={{
                          control: (base) => ({ ...base, fontWeight: '600' })
                          , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                          , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                        }}
                      />
                      {/* {formik.errors.subTagList !== undefined && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{LanguageHelp("The tags to be searched must be at least one, and the number of letters of the tags must be at least 3.")}</div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
                {/* end::Input group */}


              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='submit'
                  className='btn btn-primary mb-2'
                  data-kt-multitag-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <i className="fas fa-paper-plane"></i>
                  <span className='indicator-label'>{LanguageHelp('Submit')}</span>
                  {(formik.isSubmitting) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { AddMultipleTagModal }
